/**
 * Create a CounselingSelectedEvent
 * @param {string} counseling_type The type of counseling selected
 * @returns {*|void}
 * @constructor
 */
const CounselingSelectedEvent = function (counseling_type) {
    return (BhStructEvent('counseling', "selected")
        .setLabel('counseling_type')
        .setProperty(counseling_type));
}

const UpdatedLiveSessionCancellationEvent = function (category, action, value, label) {
    return (BhStructEvent(category, action)
        .setLabel(label)
        .setValue(value));
}

const QuizFunnelStartEvent = function () {
    return BhStructEvent('quiz_funnel', 'start');
}

const ImprovedProfilePicUIEvent = function (action, label, value, avatar_id) {
    let event = BhStructEvent('profile_picture', action);
    if (label) {
        event.setLabel(label).setProperty(value);
    }
    if (avatar_id) {
        event.setContextSchema('improved_profile_pic_ui','1-0-0');
        event.setContextData('avatar_id', avatar_id);
    }
    return event;
}

const ClientViewedPaymentEvent = function (action, label, property) {
    return BhStructEvent('payment', action)
        .setLabel(label)
        .setProperty(property);
}

const BetterSleepClickEvent = function (action, label, value) {
    if (label) {
        return BhStructEvent('bettersleep', action)
            .setLabel(label)
            .setProperty(value);
    } else {
        return BhStructEvent('bettersleep', action);
    }
}

const HomePageFAQClickEvent = function (property) {
    return BhStructEvent('homepage', 'faq_section_question_clicked')
        .setLabel('faq_question_name')
        .setProperty(property);
}

const MobileFunnelFAQClick = function (property) {
    return BhStructEvent('quiz_funnel', 'faq_footer_clicked');
}

const FailedPaymentGracePeriodEvent = function (action, label) {
    if (label) {
        return BhStructEvent('payment_failure_modal', action)
            .setLabel(label)
    } else {
        return BhStructEvent('payment_failure_modal', action);
    }
}

const PaymentFormLoadedEvent = function (location) {
    return BhStructEvent('payment', 'payment_element_loaded')
        .setLabel('payment_element_location')
        .setProperty(String(location));
}

const QuizFunnelContextEvent = function (action) {
    let event = BhStructEvent("quiz_funnel", action)
        .setContextSchema('question', '1-0-1');

    Object.assign(event, {
        setQuestionNumber: function (number) {
            return this.setContextData('question_number', number);
        },
        setQuizQuestionNumber: function (number) {
            return this.setContextData('quiz_question_number', number);
        },
        setQuestionName: function (name) {
            return this.setContextData('question_name', name);
        },
        setNextQuestion: function (question) {
            return this.setContextData('next_question', question);
        },
        setCurrentQuiz: function (quiz) {
            return this.setContextData('current_quiz', quiz);
        },
        setQuestionnaireId: function (id) {
            return this.setContextData('questionnaire_id', id);
        },
        setQuizHistory: function (quiz_history) {
            return this.setContextData('quiz_history', quiz_history);
        },
        setAnswer: function (answer) {
            return this.setContextData('answer', answer);
        }
    });
    return event;
}

const AssessmentTooltipClickedEvent = function (quiz_question_name, quiz_question_id) {
    return (BhStructEvent('quiz_funnel', 'tooltip_clicked')
        .setLabel(quiz_question_name)
        .setValue(quiz_question_id));
}

const OnboardingRedirectModalEvent = function (action, question_name, question_number, modal_passable, proposed_domain) {
    let event = BhStructEvent('onboarding_redirect_modal', action)
        .setContextSchema('onboarding-redirect-modal');

    Object.assign(event, {
        setTriggeringQuestionName: function (name) {
            return this.setContextData('triggering_question_name', name);
        },
        setTriggeringQuestionNumber: function (number) {
            return this.setContextData('triggering_question_number', number);
        },
        setModalPassable: function (modal_passable) {
            return this.setContextData('modal_passable', modal_passable);
        },
        setProposedDomain: function (proposed_domain) {
            return this.setContextData('proposed_domain', proposed_domain);
        },
        setModalResponse: function (modal_response) {
            return this.setContextData('modal_response', modal_response);
        }
    });
    return event;
}

const AccountSettingsManageMembershipClicked = function () {
    return (BhStructEvent('account_settings', "manage_membership_clicked"));
}

const ManageMembershipClick = function (action) {
    return (BhStructEvent('manage_membership', action));
}

const CancelMembershipClick = function (action) {
    return (BhStructEvent('client_quit', action));
}

const ManageMembershipChangePlanClicked = function (selected_plan) {
    return (BhStructEvent('manage_membership', "change_plan_clicked"))
        .setLabel('plan_name')
        .setProperty(selected_plan);
}

const ClientQuitReasonSelected = function (selected_reason) {
    return (BhStructEvent('client_quit', "reason_selected"))
        .setLabel('quit_reason')
        .setProperty(selected_reason);
}

const ChangeMembershipClickEvent = function () {
    return (BhStructEvent('Account_settings', "clicked_change_or_cancel_membership"));
}

const MembershipRenewalModalThroughGroupsDisplayed = function () {
    return (ClientEvent(page_info.client_id, "membership_renewal_modal_through_groups_displayed"));
}

const MembershipRenewalModalThroughGroupsClickedRenew = function (click_location) {
    return (ClientEvent(page_info.client_id, 'membership_renewal_modal_through_groups_clicked_renew'));
}

const ChangeNotificationSettingsEvent = function (unsubscribe_location, email_new_message_enabled, text_new_message_enabled, email_live_session_enabled, text_live_session_enabled, email_payment_reminders = null) {
    let event = BhStructEvent('Account_settings', 'notification_settings_updated')
        .setLabel('unsubscribe_location')
        .setProperty(unsubscribe_location)
        .setContextSchema('notification_settings_context', '1-0-1')
        .setContextData('email_therapist_message', Boolean(email_new_message_enabled))
        .setContextData('text_therapist_message', Boolean(text_new_message_enabled))
        .setContextData('email_live_session', Boolean(email_live_session_enabled))
        .setContextData('text_live_session', Boolean(text_live_session_enabled))
    ;
    if (email_payment_reminders !== null) {
        event.setContextData('email_payment_reminders', Boolean(email_payment_reminders));
    }
    return event;
}

const ClientVideoRoomRejoinModalShownEvent = function () {
    return (ClientEvent(page_info.client_id, "saw_rejoin_video_room_modal"));
}

const CounselorVideoRoomRejoinModalShownEvent = function () {
    return (CounselorEvent(page_info.counselor_id, 'saw_rejoin_video_room_modal'));
}

const ChangeMembershipModalShownEvent = function () {
    return (ClientEvent(page_info.client_id, "change_or_cancel_membership_modal_displayed"));
}

const ClientClickedCancelMembershipRadioButtonEvent = function () {
    return (BhStructEvent("client_quit", "cancel_membership_click"));
}

const ClientClickedSwitchTherapistCTAEvent = function () {
    return (BhStructEvent("client_quit", "switch_therapist_cta_click"));
}

const CounselorClickedPaymentInfoEvent = function () {
    return (BhStructEvent("therapist_account_settings", "therapist_payment_info_viewed")
        .setLabel('payment_method')
        .setValue(page_info.counselor_id));
}

const DPAConsentConferred = function () {
    return (BhStructEvent('therapist', "dpa_consent_deferred"));
}

const DPAReadAgreement = function () {
    return (BhStructEvent('therapist', "dpa_read_agreement"));
}

const ChangeMembershipModalAnsweredEvent = function (answer) {
    return (ClientEvent(page_info.client_id, "change_or_cancel_membership_modal_answered")
        .setLabel('client_selection')
        .setProperty(answer));
}

const ChangeMembershipRemindMeModalShownEvent = function () {
    return (BhStructEvent('cancellation', 'remind_me_modal_displayed'));
}

const ChangeMembershipRemindMeModalAnsweredEvent = function (answer, days) {
    return (BhStructEvent('cancellation', "remind_me_modal_answered")
            .setLabel('client_selection')
            .setProperty(answer)
            .setValue(days)
    );
}


const ClickedGroupLinkInMessageEvent = function (group_id) {
    return ClientEvent(page_info.client_id, 'clicked group link in message')
        .setLabel(String(page_info.counselor_id))
        .setProperty(String(group_id));
}

const ClientLiveSessionFeedbackQuestionAnsweredEvent = function (live_session_id, question, answer) {
    return (BhStructEvent('Post_livesession_feedback_modal', "live_session_client_feedback_answer_submitted")
            .setLabel(answer)
            .setProperty(question)
            .setValue(live_session_id)
    );
}

const ClientLiveSessionFeedbackEvent = function (action) {
    return (BhStructEvent('Post_livesession_feedback_modal', action));
}

const GroupsClickedSchedulerRightArrow = function (click_location) {
    return (BhStructEvent('groups', 'clicked_scheduler_right_arrow')
        .setLabel('click_location')
        .setProperty(click_location));
}

const GroupsClickedSchedulerLeftArrow = function (click_location) {
    return (BhStructEvent('groups', 'clicked_scheduler_left_arrow')
        .setLabel('click_location')
        .setProperty(click_location));
}

const GroupsClickedSchedulerViewAll = function (click_location) {
    return (BhStructEvent('groups', 'clicked_scheduler_view_all')
        .setLabel('click_location')
        .setProperty(click_location));
}

const GroupsClickedAllCategoriesDropdown = function () {
    return (BhStructEvent('groups', 'clicked_all_categories_dropdown'));
}

const GroupsClickedOtherFiltersDropdown = function () {
    return (BhStructEvent('groups', 'clicked_other_filters_dropdown'));
}

const GroupsClickedSchedulerCategoryShowAll = function () {
    return (BhStructEvent('groups', 'clicked_scheduler_category_show_all'));
}

const GroupsClickedSchedulerCategory = function (category_id, category) {
    return (BhStructEvent('groups', 'clicked_scheduler_category')
        .setContextSchema('clicked_scheduler_group_category_context', '1-0-0')
        .setContextData('category_id', category_id)
        .setContextData('category', category)
    );
}

const GroupsClickedSchedulerGroup = function (group_id, click_location) {
    return (BhStructEvent('groups', 'clicked_scheduler_group')
        .setContextSchema('clicked_scheduler_group_context', '1-0-0')
        .setContextData('group_id', group_id)
        .setContextData('click_location', click_location)
    );
}

const GroupsSelectedCategory = function (categories_selected) {
    return (BhStructEvent('groups', 'selected_category')
        .setContextSchema('group_category_context', '1-0-0')
        .setContextData('categories_selected', categories_selected)
    );
}

const GroupsSelectedFilter = function (filters_selected) {
    return (BhStructEvent('groups', 'selected_filter')
        .setContextSchema('group_filter_context', '1-0-0')
        .setContextData('filters_selected', filters_selected)
    );
}

const ClientQuitFreeExtensionModalDisplayed = function () {
    return (BhStructEvent('client_quit', 'free_extension_modal_shown'));
}

const ClientQuitFreeExtensionModalAnswered = function (client_selection) {
    return (BhStructEvent('client_quit', 'client_quit_free_extension_modal_answered')
        .setLabel('client_selection')
        .setProperty(client_selection)
    );
}

const MembershipPauseMembershipClicked = function (category) {
    return (BhStructEvent(category, 'pause_membership_clicked'));
}

const MembershipPauseModalDisplayed = function (displayed_reason) {
    return (BhStructEvent('pause', 'pause_membership_modal_displayed')
        .setLabel('displayed_reason')
        .setProperty(displayed_reason)
    );
}

const MembershipPauseModalAnswered = function (client_selection) {
    return (BhStructEvent('pause', 'pause_membership_modal_answered')
        .setLabel('client_selection')
        .setProperty(client_selection)
    );
}

const MembershipResumeMembershipClicked = function () {
    return (BhStructEvent('account_settings', 'resume_membership_from_pause_clicked'));
}

const MembershipResumeModalDisplayed = function (displayed_reason) {
    return (BhStructEvent('pause', 'resume_membership_modal_displayed')
        .setLabel('displayed_reason')
        .setProperty(displayed_reason)
    );
}

const MembershipResumeModalAnswered = function (client_selection) {
    return (BhStructEvent('pause', 'resume_membership_modal_answered')
        .setLabel('client_selection')
        .setProperty(client_selection)
    );
}

/**
 * Create a FAQ Question Clicked Event
 * @param {string} question_title
 * @param {string} placement 'faq_page'|'home_page'|'mobile_footer'|'user_login'
 * @param {boolean} is_optimized
 * @returns {*}
 * @constructor
 */
const FaqQuestionClickedEvent = function (question_title, placement, is_optimized = false) {
    return (BhStructEvent('faq', 'question_clicked')
        .setLabel('faq_question_name')
        .setProperty(question_title)
        .setContextSchema('faq_question_viewed', '1-0-1')
        .setContextData('faq_placement', placement)
        .setContextData('optimized_faq', Boolean(is_optimized))
    );
}


const ClientFeedbackEvent = function (action, property = null, context_data = {}) {
    let event = BhStructEvent('client_feedback', action);
    const store_review_collection_answered_actions = ['site_helpful_modal_answered','rate_app_modal_answered','improve_platform_modal_answered'];

    if (['started', 'answered', 'completed'].includes(action)) {
        event.setLabel('feedback_client_id');
    }
    if (store_review_collection_answered_actions.includes(action)) {
        event.setLabel('client_selection');
    }
    if (property) {
        event.setProperty(property);
    }
    if (action === 'answered' && Object.keys(context_data).length) {
        event.setContextSchema('feedback-client', '1-0-1');
        event.setContextData('feedback_question_id', context_data.feedback_question_id);
        event.setContextData('feedback_question', context_data.feedback_question);
        event.setContextData('feedback_client_answer', context_data.feedback_client_answer);
    }

    return event;
}

const MessageSentModalDisplayedEvent = function () {
    return (ClientEvent(page_info.client_id, "message_sent_modal_displayed"));
}

const MessageSentModalDoNotShowAgainClickedEvent = function () {
    return (ClientEvent(page_info.client_id, "message_sent_modal_do_not_show_again_clicked"));
}

const VideoSessionEvent = function (action, property) {
    return BhStructEvent('video_session', action)
        .setProperty(property);
}

const VideoSessionWebVideoStartedEvent = function (video_session_type, room_id, is_blurable, is_starting_blurred) {
    return BhStructEvent('video_session', 'web_video_started')
        .setContextSchema('video_session', '1-0-1')
        .setContextData('id', room_id)
        .setContextData('video_session_type', video_session_type)
        .setContextData('blurable', is_blurable)
        .setContextData('starting_blurred', is_starting_blurred);
}

const WaitingRoomJoinedClient = function () {
    return BhStructEvent('waiting_room', 'waiting_room_join')
}

const WaitingRoomClientExit = function () {
    return BhStructEvent('waiting_room', 'waiting_room_exit')
}

const WaitingRoomClientDropoff = function () {
    return BhStructEvent('waiting_room', 'waiting_room_dropoff')
}

const WaitingRoomMiniatureRoom = function () {
    return BhStructEvent('waiting_room', 'waiting_room_minimal_window_display')
}

const VideoRoomImproperResolution = function (join_id, resolution, label) {
    return BhStructEvent('video_room', 'zoom_improper_resolution')
        .setValue(join_id)
        .setLabel(label)
        .setProperty(resolution);
}

const VideoRoomDisconnectEvent = function (join_id, label, exit_reason) {
    return BhStructEvent('video_room', 'exit')
        .setValue(join_id)
        .setLabel(label)
        .setProperty(exit_reason);
}

const AudioRoomDisconnectEvent = function (join_id, label, exit_reason) {
    return BhStructEvent('audio_room', 'exit')
        .setValue(join_id)
        .setLabel(label)
        .setProperty(exit_reason);
}

const CounselorClickedAssessmentTooltipEvent = function () {
    return BhStructEvent('assessments', 'counselor_clicked_assessment_tooltip');
}

const TherapistOnboardingMilestoneEvent = function (action) {
    return BhStructEvent('therapist_onboarding_milestone', action);
}

const TherapistProfileStepEvent = function (action, label, property) {
    return BhStructEvent('therapist_profile_step', action)
        .setLabel(label)
        .setProperty(property);
}

const TherapistQuizEvent = (action) => {
    return BhStructEvent('therapist_quiz', action);
};

const TherapistQuizAnswerEvent = function (question_id, question_text, answer_text) {
    return BhStructEvent('therapist_quiz', 'quiz_answer')
        .setContextSchema('question', '1-0-1')
        .setContextData('question_number', question_id)
        .setContextData('question_name', question_text)
        .setContextData('answer', answer_text);
}

const TherapistGuideEvent = function (action, label = null, property = null) {
    return BhStructEvent('therapist_guide', action)
        .setLabel(label)
        .setProperty(property);
}

/**
 * Create a Counselor Notified Client Is Waiting Event
 * @param {boolean} therapist_busy
 * @param {boolean} client_just_joined
 * @param {string} selection
 * @constructor
 */
const CounselorNotifiedClientIsWaitingEvent = function (therapist_busy, client_just_joined, selection=null) {
    let action = `client_waiting_modal_${therapist_busy ? 'therapist_busy' : 'therapist_not_busy' }_${client_just_joined ? 'client_just_joined' : ''}_${selection ? 'displayed' : 'answered'}`;
    let event = BhStructEvent('video_room', action);
    if (!therapist_busy && selection) {
        event.setLabel('therapist_selection');
        event.setProperty(selection);
    }
    return event;
}

const QuitBackButtonClickedEvent = function () {
    return (BhStructEvent("client_log", "clicked_back_button_on_quit"));
}

const CounselorLogEvent = function (action, label, property, value) {
    let event = CounselorEvent(page_info.counselor_id, action)
        .setLabel(String(label))
        .setProperty(String(property))
        .setValue(value);
    return event;
}

const AssessmentsEvent = function (action) {
    return BhStructEvent('assessments', action);
}

const ExpiredRusselDiscountEvent = function (action) {
    return BhStructEvent('expired_russel_discount_attempted_modal', action);
}

const WorksheetsEvent = function (action) {
    return BhStructEvent('worksheets', action);
}

const ClientSignupEvent = function (action, label = null, property = null) {
    let event = BhStructEvent('client_signup', action);

    if (label) {
        event.setLabel(label);
    }

    if (property) {
        event.setProperty(property);
    }

    return event;
}

const ClientOnboardingEvent = function (action) {
    return BhStructEvent('client_onboarding', action);
}

const HolidayShownEvent = function (action, client_id, live_session_schedule_id, country_codes) {
    return BhStructEvent("holidays_on_client_scheduler", action)
        .setProperty(client_id)
        .setContextSchema('live_session_scheduler', '1-0-0')
        .setContextData('live_session_schedule_id', parseInt(live_session_schedule_id))
        .setContextData('country_holiday_displayed', country_codes);
}

const ClickedWriteTherapyReviewEvent = function () {
    return (ClientEvent(page_info.client_id, "clicked_write_therapist_review"));
}

const ClickedWriteReviewPostTestimonialEvent = function () {
    return (ClientEvent(page_info.client_id, "clicked_write_review_post_testimonial"));
}

const ClickedViewTherapyProfileEvent = function () {
    return (ClientEvent(page_info.client_id, "clicked_view_therapist_profile"));
}

const NoShowFeedbackRadioEvent = function (selected_text, live_session_schedule_id, client_id) {
    return BhStructEvent('session_did_not_take_place_followups', 'no_session_followup_question_answered')
        .setLabel(selected_text)
        .setProperty(String(live_session_schedule_id))
        .setValue(client_id);
}

const ClientSwitchChoiceFromManageEvent = function (client_id, account_id) {
    return BhStructEvent('switch_choice_page_modal', 'switch_choice_page_modal_displayed')
        .setLabel(String(client_id))
        .setProperty(String(account_id));
}

const ClickedChangeTherapistEvent = function () {
    return (ClientEvent(page_info.client_id, "clicked_change_therapist"));
}

const TherapistClickedToDoList = function (action, client_id = null) {
    let event = BhStructEvent('to_do_list', action);

    if (client_id) {
        event
            .setLabel('client_id')
            .setProperty(client_id);
    }

    return event;
}

const RecurringAssessmentsCounselorEvent = function (counselor_id, account_id) {
    return BhStructEvent('recurring_assessments_for_therapists', 'clicked_learn_more_instructions')
        .setLabel(counselor_id)
        .setProperty(account_id);
}

const TherapistFilterEntriesEvent = function (counselor_id, action) {
    return BhStructEvent('therapist_dashboard', action)
        .setLabel('counselor_id')
        .setProperty(counselor_id);
}

const TherapistClientProfileEvent = function(action, property = null) {
    return BhStructEvent('therapist_client_profile', action)
        .setProperty(property);
}

const ClientQuitEvent = function (action, label, property, context) {
    let event = BhStructEvent('client_quit', action)
        .setLabel(label)
        .setProperty(property);

    if (context) {
        event
            .setContextSchema('client-log', '1-0-0')
            .setContextData('client_id', page_info.client_id)
            .setContextData('action', context);
    }
    return event;
}

const SessionSchedulerTabBarClickEvent = function () {
    return BhStructEvent('session_scheduler', 'scheduler_tab_viewed');
}

const SessionSchedulerSessionCategorySelectedEvent = function (property) {
    return BhStructEvent('session_scheduler', 'session_category_selected')
        .setProperty(property);
}

const SessionSchedulerSessionDateClickEvent = function (property) {
    return BhStructEvent('session_scheduler', 'date_clicked')
        .setLabel('accessibility_status')
        .setProperty(property);
}

const SessionSchedulerSessionScheduledClickEvent = function () {
    return BhStructEvent('session_scheduler', 'schedule_session_clicked');
}

const SessionSchedulerRescheduleSessionClickEvent = function () {
    return BhStructEvent('session_scheduler', 'reschedule_clicked');
}

const SessionSchedulerAccessibilityIconClickEvent = function (property) {
    return BhStructEvent('session_scheduler', 'accessibility_icon_toggled')
        .setLabel('toggle_status')
        .setProperty(property);
}

const SessionSchedulerPhoneNumberEnteredEvent = function () {
    return BhStructEvent('session_scheduler', 'phone_number_entered');
}

const SessionSchedulerFeaturedGroupsNextClickEvent = function (property) {
    return BhStructEvent('session_scheduler', 'featured_groups_arrow_clicked')
        .setProperty(property);
}

const SessionSchedulerSmartCalendarExitedEvent = function () {
    return BhStructEvent('session_scheduler', 'smart_calendar_exited');
}

const SessionSchedulerSelectedMinuteSessionEvent = function(action) {
    return BhStructEvent('session_scheduler', action);
}
const ClientCancelSessionsEvent = function (action, label, property, context) {
    let event = BhStructEvent('client_selection', action)
        .setLabel(label)
        .setProperty(property)
        .setContextSchema('cancel_sessions_modal_answered', '1-0-0')
        .setContextData('client_id', page_info.client_id)
        .setContextData('live_session_count', context.live_session_count)
        .setContextData('group_session_count', context.group_session_count)
        .setContextData('first_live_session_schedule_id', parseInt(context.first_live_session_schedule_id))
        .setContextData('first_group_session_id', parseInt(context.first_group_session_id));
    return event;
}

const AdditionalChargeableSessionDisplayedEvent = function () {
    return BhStructEvent('session_additional_live_session_modal_displayed', 'additional_live_session_modal_displayed');
}

const AdditionalChargeableSessionAnsweredEvent = function (property) {
    return BhStructEvent('session_additional_live_session_modal_answered', 'additional_live_session_modal_answered')
        .setLabel('client_selection')
        .setProperty(property);
}

const LiveSessionEvent = function (action, label, property) {
    return BhStructEvent('live_session', action)
        .setLabel(label)
        .setProperty(property);
}

const ShowAllSessionReflectionsButtonClicked = function () {
    return BhStructEvent('session_reflections', 'show_all');
}

const EnhancedTherapistNotesEvent = function (action, counselor_id, live_session_schedule_id, entry_id) {
    return BhStructEvent('Therapist_notes', action)
        .setLabel(counselor_id)
        .setProperty(entry_id)
        .setValue(live_session_schedule_id);
}

const ClientEmergencyInfoEvent = function (action) {
    return BhStructEvent('member_contact_info_MCI', action)
        .setProperty(page_info.account_id)
        .setLabel(page_info.counselor_id);
}

const ClientJournalCsvExportEvent = function () {
    return BhStructEvent('journal', 'export_entries_clicked')
        .setValue(page_info.client_id);
}

const PresetNotesTemplatesIntroPopupViewedEvent = function () {
    return BhStructEvent('PRESET_NOTES_TEMPLATES', "intro_popup_viewed")
        .setProperty(page_info.counselor_id);
}

const PresetNotesTemplatesTemplateSelectedEvent = function (template_type) {
    return BhStructEvent('PRESET_NOTES_TEMPLATES', "template_selected")
        .setProperty(page_info.counselor_id + ", " + template_type);
}

const PresetNotesTemplatesTemplateSwitchedEvent = function (template_type) {
    return BhStructEvent('PRESET_NOTES_TEMPLATES', "template_switched")
        .setProperty(page_info.counselor_id + ", " + template_type);
}

const PresetNotesTemplatesInstructionViewedFromTemplateEvent = function () {
    return BhStructEvent('PRESET_NOTES_TEMPLATES', "instruction_viewed_from_template")
        .setProperty(page_info.counselor_id);
}

const CounselorBookmarksEvent = function (action) {
    return BhStructEvent('therapist_bookmarks', action)
        .setProperty(page_info.counselor_id);
}

const PresetNotesTemplatesInstructionViewedFromDropdownEvent = function () {
    return BhStructEvent('PRESET_NOTES_TEMPLATES', "instruction_viewed_from_dropdown")
        .setProperty(page_info.counselor_id);
}

const affiliateAudioTracking = function (action, label) {
    return BhStructEvent('affiliate_audio', action)
        .setLabel(label);
}

const ClientActionsAccountDropdownMenuOpenedEvent = function (notification_dot_visible) {
    return BhStructEvent('client_actions', "account_dropdown_menu_opened")
        .setLabel('notification_dot_visible (red dot for referral program)')
        .setProperty(notification_dot_visible);
}

const ClientActionsAccountDropdownItemClickedEvent = function (property) {
    return BhStructEvent('client_actions', "account_dropdown_item_clicked")
        .setProperty(property);
}

const ClientActionsHelpDropdownMenuOpenedEvent = function () {
    return BhStructEvent('client_actions', "help_dropdown_menu_opened");
}

const ClientActionsHelpDropdownItemClickedEvent = function (property) {
    return BhStructEvent('client_actions', "help_dropdown_item_clicked")
    .setProperty(property);
}

const ClientActionsWellnessDropdownMenuOpenedEvent = function () {
    return BhStructEvent('wellness', "wellness_tab_clicked");
}

const ClientActionsWellnessDropdownMenuItemClickEvent = function (action) {
    return BhStructEvent('client_onboarding', action);
}

const ClientActionsWellnessToolsJournalClickedEvent = function () {
    return BhStructEvent('wellness', "journal_clicked");
}

const ClientActionsWellnessToolsGoalsClickedEvent = function () {
    return BhStructEvent('wellness', "goals_clicked");
}

const ClientActionsWellnessToolsMoodTrackerClickedEvent = function () {
    return BhStructEvent('wellness', "log_my_mood_clicked");
}

const ClientActionsWellnessToolsViewMoodTrackerClickedEvent = function () {
    return BhStructEvent('wellness', "view_mood_tracker_clicked");
}

const ClientActionsWellnessTabMoodTrackerClickedEvent = function () {
    return BhStructEvent('wellness', "mood_tracker_clicked");
}

const ClientActionsWellnessTabGroupSessionsClickedEvent = function () {
    return BhStructEvent('wellness', "group_session_clicked");
}

const ClientActionsWellnessTabClassesClickedEvent = function () {
    return BhStructEvent('wellness', "class_clicked");
}

const ClientActionsWellnessTabTalkiatryEvent = function () {
    return BhStructEvent('wellness', "medication_and_psychiatry_clicked");
}

const ClientActionsWellnessTabMightierClickedEvent = function () {
    return BhStructEvent('wellness', "kids_mental_health_clicked");
}

const ClientActionsWellnessTabBetterSleepClickedEvent = function () {
    return BhStructEvent('wellness', "relaxation_and_sleep_clicked");
}

const TherapistActionsMoodTrackerClientFeatureListClickedEvent = function () {
    return BhStructEvent('mood_tracker_therapist', "clicked_in_client_feature_list");
}

const TherapistActionsMoodTrackerClientFeatureListOpenEvent = function () {
    return BhStructEvent('mood_tracker_therapist', "open_client_mood_tracker_clicked_in_client_feature_list");
}

const ClientReferrerEvent = function (action, source, options) {
    return BhStructEvent('referral', action)
        .setContextSchema('referral_modal_context', '1-0-0')
        .setContextData('source', source)
        .setContextData('modal', options.referral_modal)
        .setContextData('referral_offer_code', options.referral_offer_code)
        .setContextData('weeks_given', options.weeks_given)
        .setContextData('share_type', options.share_type)
        .setContextData('clicked_info', options.clicked_info)
        .setContextData('referree_client_id', options.referree_client_id);
}

const CopyReferralEmailLink = function () {
    return BhStructEvent('\n' +
        'therapist_referral', 'copy_referral_link');
}

const TherapistReferralEmailInvite = function () {
    return BhStructEvent('\n' +
        'therapist_referral', 'send_referral_link')
        .setLabel('referred_therapist_email')
        .setProperty('email');
}

const TherapistStatsViewTrend = function (question) {
    return BhStructEvent('stats_tab_reorganization', 'clicked_view_trend')
        .setLabel('question')
        .setProperty(question);
}

const GroupsFunnelApplicationApprovalModalDisplayed = function () {
    return (BhStructEvent('groups_funnel', 'application_approval_modal_displayed'));
}

const GroupsFunnelApplicationCanceled = function () {
    return (BhStructEvent('groups_funnel', 'application_cancelled'));
}

const GroupsFunnelApplicationApprovalModalAnswer = function (selection) {
    return BhStructEvent('groups_funnel', 'application_approval_modal_answered')
        .setLabel('therapist_selection')
        .setProperty(selection);
}

const GroupsFunnelApplicationCancellationModalDisplayed = function () {
    return (BhStructEvent('groups_funnel', 'application_cancellation_modal_displayed'));
}

const GroupsFunnelApplicationCancellationModalAnswer = function (therapist_selection) {
    return BhStructEvent('groups_funnel', 'application_cancellation_modal_answered')
        .setLabel('therapist_selection')
        .setProperty(therapist_selection);
}

const ViewedTherapistProfile = function (counselor_id, client_id) {
    return BhStructEvent('therapist_selection', 'viewed_profile')
        .setContextSchema('viewed_therapist_profile', '1-0-1')
        .setContextData('counselor_id', parseInt(counselor_id))
        .setContextData('client_id', parseInt(client_id));
}

const ChoseATherapist = function (counselor_id, client_id) {
    return BhStructEvent('therapist_selection', 'chose_a_therapist')
        .setContextSchema('chose_a_therapist', '1-0-1')
        .setContextData('counselor_id', parseInt(counselor_id))
        .setContextData('client_id', parseInt(client_id));
}

const TherapistDetailUpdate = function (action, client_id) {
    return BhStructEvent('therapist_dashboard', action)
        .setProperty('client_id')
        .setValue(client_id);
}

const TherapistDashboardTabClick = function (action) {
    action = action === 'scores' ? 'stats' : action;

    return BhStructEvent('therapist_dashboard', action);
}

const PrivacyBannerScrolled = function () {
    return BhStructEvent('privacy', 'banner_scrolled');
}

const AsyncFamiliarizationEvent = function (counselor_id, action) {
    return BhStructEvent('async_guided_interview_mitek', action)
        .setLabel(counselor_id);
}

const ClientSmartCalendarModalShownEvent = (source) => {
    return BhStructEvent('client_settings', 'client_smart_calendar_modal_shown')
        .setLabel('source')
        .setProperty(source)
}

const SessionReflectionEvent = function (action, value, is_response = false) {
    let label = 'session_reflection_id';
    if (is_response) {
        label = 'session_reflection_response_id';
    }
    return BhStructEvent('session_reflection', action)
        .setValue(value)
        .setLabel(label);
}

const TherapistMobileExpandCollapse = (action) => {
    return BhStructEvent('therapist_mobile_message_editor', action);
}

const TherapistComposerExpandContractZoom = (action, property, value) => {
    return BhStructEvent('therapist_composer', action)
        .setProperty(property)
        .setValue(value);
}

const TherapistSignupComparison = (action, counselor_new_application_id, item = '') => {
    let event = BhStructEvent('therapist_lp_comparison', action).setLabel(counselor_new_application_id);
    if (action === 'click_i') {
        return event.setProperty(item);
    }
    return event;
}

const TherapistOnboardingFunnel = (action, video) => {
    const event = BhStructEvent('onboarding_funnel', action);
    if (video) {
        event.setLabel('video_name').setProperty(video);
    }
    return event;
}

const ScrolledToBottomOfHomepageEvent = () => {
    return BhStructEvent('homepage', 'scrolled_to_bottom_of_page');
}

const TherapistOpportunitiesEvent = (action, property = null) => {
    let event = BhStructEvent('therapist_opportunities', action);

    if (property) {
        event.setProperty(property);
    }

    return event;
}

const ClientRematchingEvent = (action, counselor_id, value, property = null) => {
    let event = BhStructEvent('re_matching', action)
        .setLabel(counselor_id)
        .setValue(value);

    if (property) {
        event.setProperty(property);
    }

    return event;
}

const PostMatchOnboardingEvent = (action, source) => {
    if (!action) {
        return;
    }

    let event = BhStructEvent('client_log', action)
    if (source) {
        event.setLabel('source');
        event.setProperty(source);
    }
    return event;
}

const GoalsInOnboardingFlowEvent = (event, action, property, label) => {
    return BhStructEvent(event, action)
        .setProperty(property)
        .setLabel(label)
}

const ClientCXLReasonsEvent = (action, live_session_schedule_id, property, label) => {
    return BhStructEvent('client_livesession', action)
        .setProperty(property)
        .setLabel(label)
        .setValue(live_session_schedule_id);
}

/**
 * @param {string} sorting_item
 * @param {string} which_tab
 */
const DashboardSortEvent = (sorting_item, which_tab) => {
    return BhStructEvent('sort_therapist_dash', 'click_sorting_icon')
        .setProperty(sorting_item)
        .setLabel(which_tab);
}

const GiftEvent = function (property, action) {
    return BhStructEvent('gift', action)
        .setProperty(property);
}

const ClientSurveyModalShownEvent = function (survey_name) {
    return BhStructEvent('client_survey', 'modal_shown')
        .setLabel('survey_name')
        .setProperty(survey_name);
}

const ClientSurveyModalAnsweredEvent = function (survey_name) {
    let event = BhStructEvent('client_survey', 'modal_answered')
        .setContextSchema('client-survey-answered', '1-0-0');

    if (survey_name) {
        event.setLabel('survey_name');
        event.setProperty(survey_name);
    }

    Object.assign(event, {
        setAnswer: function (answer) {
            return this.setContextData('answer', answer);
        }
    });

    return event;
}

const ElasticFantasticSaveMultipleSlotsEvent = (slots_added, session_length, time_between_slots) => {
    return BhStructEvent('elastic_fantastic_sessions', 'hit_save_for_adding_multiple_slots')
        .setValue(slots_added)
        .setProperty(session_length)
        .setLabel(time_between_slots);
}

const ElasticFantasticNudgeEvent = (property) => {
    return BhStructEvent('elastic_fantastic_sessions', 'add_or_subtract_5_mins')
        .setProperty(property);
}

const SocialLinkClickEvent = function (link) {
    return (BhStructEvent('social_media_icon_clicked', link));
}

const TherapistStackableAnnouncementEvent = (action) => {
    return BhStructEvent('stackable_announcement', action);
}

const TherapistMultipleSessionsV2Event = (action) => {
    return BhStructEvent('multiple_sessions_v2', action);
}

const TherapistEngagementEvent = (action, value = null, label = null, property = null) => {
    let event = BhStructEvent('therapist_engagement', action);

    if (value) {
        event.setValue(value);
    }

    if (label) {
        event.setLabel(label);
    }

    if (property) {
        event.setProperty(property);
    }

    return event;
}

const CrossStateBonusModalLinkEvent = function (action) {
    return BhStructEvent('modal_redirect', action)
        .setLabel('modal_name')
        .setProperty('state_license_bonus_info');
}

const TherapistActivitiesLog = function (action, counselorId) {
    return BhStructEvent('therapist_activities_log', action)
        .setProperty(counselorId);
}

const GoalsRedesignClickEvent = function (goal_instance_id, action, label, value, property) {
    let event = BhStructEvent('goal', action)
        .setContextSchema('goal_instance_context', '1-0-0')
        .setContextData('goal_instance_id', goal_instance_id);

    if (label) {
        event.setLabel(label);
    }

    if (value) {
        event.setValue(value);
    }

    if (property) {
        event.setProperty(property);
    }

    return event;
}

const TherapistDueDateUiSwitchEvent = function (property) {
    return BhStructEvent('therapist_dashboard', 'due_date_ui_changed')
        .setLabel('resulting_ui')
        .setProperty(property);
}

const LsBookingConfirmationModalEvent = (action, live_session_schedule_id, property = null) => {
    if (!property) {
        property = page_info.is_nudge_modal_book_session ? 'nudge_modal' : 'scheduler';
    }

    property = (property === 'scheduler' && page_info.is_multisessions) ? 'multiple_sessions_scheduler' : property;

    return (BhStructEvent('ls_booking_confirmation_modal', action))
        .setValue(live_session_schedule_id)
        .setProperty(property);
}

const OrgSessionRequestModalDisplayedEvent = function () {
    return BhStructEvent('org_session_request_modal', 'displayed');
}


const SecurePaymentModalDisplayedEvent = function (location) {
    return BhStructEvent('payment', 'secure_transaction_link_triggered')
        .setLabel('trigger_location')
        .setProperty(location);
}

const AcceptDeclineClient = function (action, slotsAvailable) {
    return BhStructEvent('therapist_engagement', action)
        .setLabel('slots_available')
        .setProperty(slotsAvailable);
}

const PasteModalEvent = function (action) {
    return BhStructEvent('therapist_engagement', action);
}

const MitigateAbandonmentMoreSuccessStoriesClicked = function (tab) {
    return BhStructEvent('go_page', 'clicked_more_success_stories')
            .setLabel('opened_in')
            .setProperty(tab);
}

const CounselorViewedCompletedWorksheetEvent = function (client_id, worksheet_id) {
    return BhStructEvent('counselor_log', 'viewed_a_completed_worksheet')
        .setLabel(client_id)
        .setProperty(worksheet_id);
}

const ClientDownloadedPersonalDataEvent = function () {
    return BhStructEvent('privacy', 'personal_data_export_success')
        .setLabel(page_info.client_id);
}

const TherapistEarningProjectionsSetGoal = function (contextData) {
    let event = TherapistEarningProjections('caseload_goal_save');
    event.setContextSchema('therapist_earnings_projections_context', '1-0-0')
    for (const field in contextData) {
        event.setContextData(field, contextData[field]);
    }
    return event;
}

const TherapistEarningProjections = function (action, property, label) {
    let event = BhStructEvent('therapist_earnings_projections', action);
    if (label !== undefined) {
        event.setLabel(label);
    }
    if (property !== undefined) {
        event.setProperty(property);
    }
    return event
}

const TherapistInsuranceEvent = function (action, label, property) {
    let event = BhStructEvent('therapist_insurance', action);
    if (label !== undefined) {
        event.setLabel(label);
    }
    if (property !== undefined) {
        event.setProperty(property);
    }
    return event;
}

const SessionSnapEvent = (action) => {
    return BhStructEvent('sessionsnap', action);
}

const SessionSnapSettingEvent = (action, label, property) => {
    return SessionSnapEvent(action).setLabel(label).setProperty(property);
}

const ChinaConsentEvent = function (action, property) {

    // validation
    if (!['shown_china_consent', 'accepted_china_consent'].includes(action)) {
        if (typeof trackJs != "undefined") {
            trackJs.track('Invalid action');
        }
        return;
    }
    if (!['signup_funnel', 'login'].includes(property)) {
        if (typeof trackJs != "undefined") {
            trackJs.track('Invalid property');
        }
        return;
    }

    return BhStructEvent('privacy', action)
        .setLabel('viewed_from')
        .setProperty(property);
}

const SessionReflectionV2Event = function (action, label, property) {
    let event = BhStructEvent('session', action)

    if (label !== undefined) {
        event.setLabel(label)
    }
    if (property !== undefined) {
        event.setProperty(property)
    }

    return event
}

const SessionReflectionV2JournalEvent = function (action, label, property) {
    let event = BhStructEvent('journal', action)

    if (label !== undefined) {
        event.setLabel(label)
    }
    if (property !== undefined) {
        event.setProperty(property)
    }

    return event
}
const ExperimentUltrahumanRingPromoEvent = function (action) {
    const event = BhStructEvent('payment', action);
    event.setLabel(page_info.client_id);
    return event;
}

const TherapistShortcutsEvents = function (action, label = null) {
    return BhStructEvent('Therapist_Shortcuts', action)
        .setLabel(label);
}

const PasswordSeenInBreachModalEvent = (action, is_compromised) => {
    return BhStructEvent('client_log', action)
        .setValue(is_compromised);
}

const LoggedOutUnsubscribeEvent = (action) => {
    return BhStructEvent('cancel_membership', action)
}

const DiscountQuarterlyOfferEvent = function (action) {
    return BhStructEvent('quarterly_offer', action);
}

const EarningsCalculatorV2Events = function (action, label = null) {
    return BhStructEvent('therapist_earnings_estimator_v2', action)
        .setLabel(label);
}

const ClientPostCCQuestionEvent = function (action, label = null, property = null, answers = null) {
    const event = BhStructEvent('client_onboarding', action);
    if (label !== null && property !== null) {
        event.setLabel(label);
        event.setProperty(property);
    }
    if ((action === 'prefer_session_times_question_answered' || action === 'prefer_session_days_question_answered') && answers !== null) {
        event.setContextSchema('client_onboarding_question_answer_context', '1-0-0');
        const comma_answers = answers.join(', ');
        event.setContextData('answer', comma_answers);
    }

    return event;
}

const ClientEngagementEvent = (action, label = null, property = null) => {
    const event = BhStructEvent('client_engagement', action);

    if (label) {
        event.setLabel(label);
    }

    if (property) {
        event.setProperty(property);
    }

    return event;
}

const VibeCheckEvent = (action, label = null, property = null) => {
    const event = BhStructEvent('vibe_check', action);

    if (label) {
        event.setLabel(label);
    }

    if (property) {
        event.setProperty(property);
    }

    return event;
}

const LanguageSelectorEvent = (action, label = null, property = null) => {
    const event = BhStructEvent('user_settings', action);

    if (label) {
        event.setLabel(label);
    }

    if (property) {
        event.setProperty(property);
    }

    return event;
}

const ClientInsuranceEvent = (action) => BhStructEvent('client_insurance', action);

const ClientInsuranceSwitchChoiceMedicalReleaseViewedEvent = () => ClientInsuranceEvent('viewed_begin_therapy_switch_medical_release_modal');

const ClientInsuranceSwitchChoiceMedicalReleaseConsentEvent = (property) => ClientInsuranceEvent('medical_release_consent_switch_therapist').setProperty(property);

const MatchingWithInNetworkTherapistModalShownEvent = () => ClientInsuranceEvent('matching_in_network_therapist_modal_shown');

const MatchingWithInNetworkTherapistModalClientClickedCloseEvent = () => ClientInsuranceEvent('matching_in_network_therapist_modal_client_clicked_close');

const MatchingWithInNetworkTherapistModalClosedBecauseMatchedEvent = () => ClientInsuranceEvent('matching_in_network_therapist_modal_closed_because_matched');

const ClientCompleteIntakeModalShownEvent = () => {
    return BhStructEvent('client_insurance', 'complete_intake_for_session_modal_shown');
}

const ClientCompleteIntakeModalSelectionEvent = (property) => {
    const event = BhStructEvent('client_insurance', 'complete_intake_for_session_modal_selection');
    event.setProperty(property);
    return event;
}

const SessionSchedulerInsurancePriceShownEvent = (price, priceRaw) => {
    const event = BhStructEvent('client_insurance', 'session_scheduler_insurance_price_shown');
    event.setLabel(price);
    event.setProperty(priceRaw);
    return event;
}

const Button2FADisablementEvent = function (action, property) {
    const event = BhStructEvent('engagement', action);

    if (property) {
        event.setProperty(property);
    }

    return event;
}

// TB-2393 RENEW_CAKE_ONBOARDING EXP
const RenewCakeOnboardingEvent = function (action, property = null) {
    const event = BhStructEvent('caked_client', action);

    if (property) {
        event.setProperty(property);
    }

    return event;
}

const EapConsentEvent = function (action) {
    return BhStructEvent('eap_consent', action)
}
